import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { ListingType } from '@smg-real-estate/hg-search-libs';
import Cookies from 'js-cookie';

import {
  GTMPageFeatureId,
  GTMPageType,
  TrackingFormattedListingType,
} from '@/helpers/GTM/GTMParameters';

export function getBasicPageViewTrackingContext(
  pageType: GTMPageType,
  language: HgSupportedLanguage,
  fullRoutePath: string,
  normalizedFullRoutePath: string | null,
): {
  tech_release: string;
  page_realUrl: string;
  h_web_feature_id_019: GTMPageFeatureId;
  page_type: GTMPageType;
  tech_env: string;
  page_contentLanguage: HgSupportedLanguage;
} {
  return {
    h_web_feature_id_019: GTMPageFeatureId.INITIAL_PAGE_LOAD,
    page_type: pageType,
    page_contentLanguage: language,
    page_realUrl: `${import.meta.env.VUE_APP_BASE_URL}${fullRoutePath}`,
    ...(normalizedFullRoutePath !== null && {
      page_normalizedUrl: `${import.meta.env.VUE_APP_BASE_URL}${normalizedFullRoutePath}`,
    }),
    tech_release: `6_${import.meta.env.VUE_COMMIT_SHA}`,
    tech_env: import.meta.env.VUE_STAGE,
  };
}

export const convertListingTypeToValuesForTracking = (
  value: ListingType | undefined,
): TrackingFormattedListingType => {
  const listingTypeValue: string = (value && ListingType[value].toLowerCase()) || '';
  const [trackingFormattedKey] =
    Object.entries(TrackingFormattedListingType).find(
      ([_, trackingFormattedValue]) => trackingFormattedValue === listingTypeValue,
    ) ?? [];
  return (
    (trackingFormattedKey &&
      TrackingFormattedListingType[
        trackingFormattedKey as keyof typeof TrackingFormattedListingType
      ]) ||
    TrackingFormattedListingType.STANDARD
  );
};

export const convertListingTypesToValuesForTracking = (
  listingTypes: (ListingType | undefined)[],
): string[] =>
  listingTypes.map((listingType) => convertListingTypeToValuesForTracking(listingType));

export function storeLanguageInCookie(language: HgSupportedLanguage): void {
  let domain = window.location.hostname;

  // setting cookie for .www.homegate.ch (with leading dot)
  Cookies.set('homegate_language', (language as string).toUpperCase(), {
    domain: domain,
    expires: 90,
  });

  if (domain.startsWith('www.')) {
    domain = domain.substring('www.'.length);
    // setting cookie for .homegate.ch (with leading dot)
    Cookies.set('homegate_language', (language as string).toUpperCase(), {
      domain: domain,
      expires: 90,
    });
  }

  // setting cookie for www.homegate.ch (without leading dot)
  Cookies.set('homegate_language', (language as string).toUpperCase(), {
    expires: 90,
  });
}
